/**
 * @flow
 */

import React, { useState } from "react"
import styled from "styled-components"

type Props = {
  field: Object,
  form: Object,
  type?: string,
  label?: string,
  multiline?: boolean,
  normalize?: Function,
  helpText?: string,
}

const Container = styled.div`
  margin-bottom: 1rem;
  label {
    display: inline-block;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
  p {
    position: relative;
    input,
    textarea {
      border: none;
      border-radius: 8px;
      padding: 0.75rem;
      background-color: var(--white);
      width: 100%;
      font-size: 0.9rem;
      &:focus {
        outline: none;
        box-shadow: 2px 2px 10px -8px rgba(0, 0, 0, 0.5);
      }
    }
    input.has-toggle {
      padding-right: 4rem;
    }
  }
  .password-toggle {
    position: absolute;
    top: 50%;
    right: 0.75rem;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 0.8rem;
    color: var(--havelock-blue);
    &:focus {
      outline: none;
    }
  }
  .help-text {
    font-size: 0.8rem;
    padding: 0.5rem 0 0 0.5rem;
    display: block;
    color: #8f90a3;
    line-height: 1.4;
  }
  span {
    font-size: 0.9rem;
    padding: 0.5rem 0 0 0.5rem;
    display: inline-block;
    color: var(--pomegranate);
  }
`

const TextField = ({
  field,
  form,
  type = "text",
  label = "",
  multiline = false,
  normalize = v => v,
  helpText = "",
  ...props
}: Props) => {
  const error = form.errors[field.name] && form.touched[field.name]
  const isPassword = type === "password"
  const [visible, setVisible] = useState(false)
  const inputType = isPassword && visible ? "text" : type

  const handleBlur = () => {
    form.setFieldTouched(field.name, true)
  }

  const handleChange = event => {
    const value = normalize(event.target.value)
    form.setFieldValue(field.name, value)
  }

  const toggleVisible = () => {
    setVisible(!visible)
  }

  return (
    <Container>
      <label>{label}</label>
      <p>
        {multiline ? (
          <textarea
            onBlur={handleBlur}
            onChange={handleChange}
            value={field.value}
            {...props}
          />
        ) : (
          <input
            type={inputType}
            className={isPassword ? "has-toggle" : ""}
            onBlur={handleBlur}
            onChange={handleChange}
            value={field.value}
            {...props}
          />
        )}
        {isPassword && (
          <button
            type="button"
            className="password-toggle"
            onClick={toggleVisible}
            tabIndex={-1}
          >
            {visible ? "Hide" : "Show"}
          </button>
        )}
      </p>
      {helpText ? <small className="help-text">{helpText}</small> : null}
      <span> {error ? form.errors[field.name] : ""} </span>
    </Container>
  )
}

export default TextField
